import { supabase } from './supabase';
import { calcLate, minutesInOrgTz } from './policy';

// Calcula la tardanza de una entrada cargada a mano, con el horario del día (o su excepción) y la regla de la organización.
export const withLateness = async (employeeId, date, extra = {}) => {
  if (!extra.check_in) return extra;
  try {
    const dow = new Date(date + 'T12:00:00').getDay();
    const [{ data: ex }, { data: sc }] = await Promise.all([
      supabase.from('schedule_exceptions').select('type,start_time').eq('employee_id', employeeId).eq('date', date).maybeSingle(),
      supabase.from('schedules').select('start_time,tolerance_minutes,effective_from,effective_to').eq('employee_id', employeeId).eq('active', true).eq('day_of_week', dow),
    ]);
    if (ex?.type === 'free') return { ...extra, minutes_late: 0 };
    const sched = (sc || []).filter((s) => (!s.effective_from || s.effective_from <= date) && (!s.effective_to || s.effective_to >= date))
      .sort((a, b) => String(b.effective_from || '').localeCompare(String(a.effective_from || '')))[0];
    const startStr = ex?.start_time || sched?.start_time;
    if (!startStr) return { ...extra, minutes_late: 0 };
    const expected = Number(startStr.slice(0, 2)) * 60 + Number(startStr.slice(3, 5));
    const actual = minutesInOrgTz(extra.check_in);
    return { ...extra, minutes_late: calcLate(Math.max(0, actual - expected), ex?.start_time ? null : (sched?.tolerance_minutes ?? null)) };
  } catch (e) { return { ...extra, minutes_late: 0 }; }
};
